import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_maintain_job_descs_for_all_positions_win_the_fac'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_maintain_job_descs_for_all_positions_win_the_fac',
  name: 'Does the facility maintain job descriptions for all positions within the facility?',
  description:
    'The intent of this question is to understand if there are written job descriptions for all positions within the facility. \r\r\n\r\r\nA "job description" refers to a formal written statement detailing the requirements and responsibilities of a specific position.\r\r\n\r\r\n"Maintained" refers to keeping copies of job descriptions on-site at the facility and in an orderly fashion.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ep-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5940,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
